import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { DuplicateImportSetItemWire, ImportSetItemWire } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadImportSet: async (id: number): Promise<ImportSetItemWire> => {
    const response = await new RemoteAdminData(endpoints.importSetItem)
      .resource<ApiResponse<ImportSetItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteImportSet: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.importSetItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  addImportSet: async (importSet: ImportSetItemWire, urlParams?: { [key: string]: boolean }): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.importSetItem)
      .resource<ApiResponse<number>>()
      .filter(urlParams)
      .create(importSet, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  duplicateImportSet: async (id: number, importSet: DuplicateImportSetItemWire): Promise<number> => {
    const response: any = await new RemoteAdminData(endpoints.duplicateImportSet(id))
      .resource<ApiResponse<number>>()
      .create(importSet, false);

    const json: ApiResponse<number> = await response.json();

    return json.data;
  },

  updateImportSet: async (id: number, importSet: ImportSetItemWire): Promise<number> => {
    await new RemoteAdminData(endpoints.importSetItem)
      .resource<void>()
      .withId(id)
      .save(importSet);

    return id;
  }
};
